<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-header class="d-flex justify-between align-items-end">
            <slot name="header" :params="params" />

            <export-button
                :api-url="exportUrl"
                :label="$t('Export as Excel')"
                icon="file-excel"
                class="ml-3"
            />
        </b-card-header>

        <b-card-body class="align-items-center">
            <no-results-found v-if="!pending && !items.length" class="mb-0" />

            <ul v-if="items.length" class="timeline">
                <revision-history-item
                    v-for="revision in items"
                    :key="revision.id"
                    :revision="revision"
                />
            </ul>
        </b-card-body>

        <b-card-footer v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                class="mb-0"
            />
        </b-card-footer>
    </div>
</template>

<script>
    import fetchPaginatedData from "@/mixins/fetchPaginatedData";
    import RevisionHistoryItem from "@/components/RevisionHistoryItem";
    import ExportButton from "@/components/ExportButton";

    export default {
        name: 'RevisionHistory',
        components: {ExportButton, RevisionHistoryItem},
        mixins: [fetchPaginatedData],
        props: {
            apiUrl: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                params: {
                    user_id: ''
                },
            }
        },
        computed: {
            exportUrl() {
                return this.apiUrl + '/csv?' + new URLSearchParams(Object.assign({}, this.params, {token: this.$auth.token()})).toString()
            }
        },
    };
</script>
